export default "__VITE_ASSET__BpIPrJ5b__"